export enum AlertType {
  Info = 'Info',
  Error = 'Error',
  Success = 'Success',
}
